import { IMessage } from '@mnz-core/models/message';
import { createAction, props } from '@ngrx/store';
import { TypedAction } from '@ngrx/store/src/models';

export const addMessage = createAction(
  '[App] Add Message',
  props<{ action?: TypedAction<string>; message: IMessage }>()
);

export const deleteMessage = createAction('[App] Delete Message', props<{ id: string }>());
export const clearMessages = createAction('[App] Clear Messages');
